import React from 'react';
import { Box, Typography } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

export const CONFIGURATION_ERROR_COLOR = '#d14343';
export const CONFIGURATION_ERROR_BACKGROUND = 'linear-gradient(135deg, #d14343 0%, #a92f3b 100%)';

const getErrorMessage = (error) => String(
  typeof error === 'string' ? error : error?.message || ''
).trim();

const ConfigurationErrorSummary = ({ error, t, sx = {} }) => {
  const message = getErrorMessage(error);
  if (!message) return null;

  return (
    <Box
      role="alert"
      aria-live="polite"
      data-testid="configuration-error-summary"
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        pt: 1.25,
        mt: 1.25,
        borderTop: '1px solid rgba(255,255,255,0.28)',
        color: '#fff',
        ...sx,
      }}
    >
      <ErrorOutlineRoundedIcon sx={{ fontSize: 19, mt: 0.15, flexShrink: 0 }} />
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="caption" sx={{ display: 'block', fontWeight: 800, lineHeight: 1.25 }}>
          {t ? t('dag.node_error_title', 'Needs attention') : 'Needs attention'}
        </Typography>
        <Typography
          variant="caption"
          sx={{ display: 'block', mt: 0.25, lineHeight: 1.35, overflowWrap: 'anywhere' }}
        >
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default ConfigurationErrorSummary;
